















import { Vue, Component } from "vue-property-decorator";
import { IIconMenu } from "@/components/shared/types";

const ADMIN_JOBS: IIconMenu[] = [{
  icon: 'cloud_upload',
  title: 'uploadCropData'
},{
  icon: 'business',
  title: 'adminOrganizations'
},{
  icon: 'people_outline',
  title: 'adminUsers'
}];

@Component
export default class UserLogin extends Vue {
  adminJobs: IIconMenu[] = ADMIN_JOBS;
  
  get SelectedApp() : string {
    return this.$store.getters.SelectedApp;
  };

  set SelectedApp(app:string) {
    this.$store.commit('notifyChange', {
      SelectedApp: app
    });
  }
}
